import BaseListStyle from "../../styles/BaseListStyle"; 

const CostingsStyles = (theme) => { 
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
    checkbox: {
      minWidth: "100px",
      margin: "0px 5px"
    },
    costingsList: {
      "& .MuiTableHead-root": {
        display: "block",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
    },
    costingsListEdit: {
      "& .MuiTableHead-root": {
        display: "table",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
    },
    button: {
      margin: theme.spacing(1),
      padding: 6,
      marginTop: 12,
    },
    costingCargoEditor: {
      "& .MuiTableHead-root": {
          backgroundColor: theme.palette.childTableHeader.backgroundColor,
          display: "block",
          tableLayout: "fixed",
          paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
          color: theme.palette.secondary.main,
      }
    },
    costingSectorsEditor: {
      "& .MuiTableHead-root": {
          backgroundColor: theme.palette.childTableHeader.backgroundColor,
          display: "block",
          tableLayout: "fixed",
          paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
          color: theme.palette.secondary.main,
      }
    },
    costingCommissionEditor: {
      "& .MuiTableHead-root": {
          backgroundColor: theme.palette.childTableHeader.backgroundColor,
          display: "block",
          tableLayout: "fixed",
          paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
          color: theme.palette.secondary.main,
      }
    },
    flightCosts: {
      "& .MuiTableCell-root": {
        padding: 8,
      }
    },
    groundCosts: {
      "& .MuiTableCell-root": {
        padding: 8,
      },
      "& .MuiTableCell-root.MuiTableCell-paddingNone": {
        padding: 0
      },
    },
    revenue: {
      "& .MuiTableCell-root": {
        padding: 8,
      }
    },
    operatingCosts: {
      "& .MuiTableCell-root": {
        padding: 8,
      }
    },
    summaryTotals: {
      "& .MuiTableCell-root": {
        padding: 8,
      }
    },
    summaryPerHour: {
      "& .MuiTableCell-root": {
        padding: 8,
      },
      "& .MuiTableRow-head .MuiTableCell-root": {
        padding: 8,
        paddingBottom: 5
      }
    },
    grossErrorCheck: {
      "& .MuiTableCell-root": {
        padding: 8,
      },
      "& .MuiTableBody-root .MuiTableRow-root.hasErrors .MuiTableCell-body": {
        backgroundColor: "#cc4040",
        color: "#ffffff"
      },
      "& .MuiTableBody-root .MuiTableRow-root .MuiTableCell-body.isTotal": {
        backgroundColor: "#d9d9d9",
        color: "#00000"
      },
      "& .MuiTableBody-root .MuiTableRow-root.hasErrors .MuiTableCell-body.isTotal": {
        backgroundColor: "#cc0000",
        color: "#ffffff"
      },
    },
    costBreakdownTooltip: {width: 500, maxWidth: 500, fontSize: 12},
    costingTooltip: {width: 350, maxWidth: 350, fontSize: 12},
    fuelTooltip: {width: 250, maxWidth: 250, fontSize: 12}
  }
}

export default CostingsStyles;


